import axios, { AxiosError } from 'axios';
import { CARTEIRA_URL, CARTEIRA_OAUTH_CLIENT_ID, CARTEIRA_OAUTH_CLIENT_SECRET } from 'domain/infra/data/env';
import { CarteiraOAuthResponse, CarteiraOAuthRequest } from '../../types/auth/carteiraOAuthResponse';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';

export class CarteiraOAuthService {
    async GetToken(): Promise<CarteiraOAuthResponse | Error> {
        try {
            const usuarioId = _UserData.Get<string>(UserDataBaseEnum.UsuarioID);
            const rawTokenAES = _UserData.Get<string>(UserDataBaseEnum.TokenAES);
            const tokenAES = rawTokenAES ? decodeURIComponent(rawTokenAES) : rawTokenAES;

            const request: CarteiraOAuthRequest = {
                grant_type: 'client_credentials',
                client_id: CARTEIRA_OAUTH_CLIENT_ID,
                client_secret: CARTEIRA_OAUTH_CLIENT_SECRET,
                claims: {
                    UsuarioID: usuarioId,
                    Token: tokenAES,
                },
            };

            const response = await axios.post<CarteiraOAuthResponse>(
                `${CARTEIRA_URL}/oauth2/token`,
                request
            );

            return response.data;
        } catch (error) {
            const axiosError = error as AxiosError;
            const errorMessage = axiosError.response?.data
                ? (typeof axiosError.response.data === 'string'
                    ? axiosError.response.data
                    : JSON.stringify(axiosError.response.data))
                : axiosError.message || 'Erro ao obter token OAuth2 da Carteira';
            return new Error(errorMessage);
        }
    }
}
